import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const defaultLang = import.meta.env.VITE_DEFAULT_LANG || 'zh';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: defaultLang,
    fallbackLng: defaultLang,
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;